import {
  BrochureCTA,
  FloatingSection,
  Header,
  Intro,
  KitchenExploreCTA,
  NewsWidget,
  PartnerTicker,
  QuickLinks,
} from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";

export default function BespokeSolutions() {
  return (
    <div>
      <Header
        title={t(routes.bespokeSolutions, "title")}
        image={t(routes.bespokeSolutions, "image")}
        bgColor="black"
        className="text-white"
      >
        <p>
          With a proven track record of delivering into exclusive urban
          developments, our projects team can take a design concept, or
          architect’s specification, and create a first-class product.
        </p>
      </Header>
      <Intro title="Beyond the standard" bgColor="black" />
      <PartnerTicker />
      <div className="mt-10 space-y-20">
        <FloatingSection
          bgColor="white"
          className="min-h-[340px]"
          image="media/assets/bespoke-solutions-item-1.jpg"
          title={
            <>
              <p className="font-medium">
                Flexibility within our UK manufacturing capability, combined
                with our in-house distribution, nationwide installation and
                project management skills, makes us the obvious partner for
                delivering schemes on time and to scope.
              </p>
            </>
          }
        />
        <FloatingSection
          reverse
          className="min-h-[340px]"
          image="media/assets/bespoke-solutions-item-2.jpg"
          title={
            <>
              <h3 className="text-lg font-light">Without limitations</h3>
              <p className="font-medium">
                We’re not just a company with a standard offering of products.
                We can diversify and create solutions to a specific brief,
                working closely with our supply partners, at home and worldwide,
                to create the best solution for your development.
              </p>
            </>
          }
        />
        <FloatingSection
          bgColor="white"
          className="min-h-[340px]"
          image="media/assets/bespoke-solutions-item-3.jpg"
          title={
            <>
              <h3 className="text-lg font-light">Bespoke</h3>
              <p className="font-medium">
                We welcome customers who present us with challenges requiring a
                solution yet to be created. We provide innovative responses to
                realise the client’s design intent, while also offering value
                engineering alternatives to keep the ‘look’ without the ‘cost’
                of a full, bespoke solution.
              </p>
            </>
          }
        />
      </div>
      <BrochureCTA
        text="Find out more about how we help house builders achieve their goals across their high rise developments."
        image="/media/assets/brochure-developers.jpg"
        link="https://issuu.com/paularosamanhattan/docs/prmf-major-projects-brochure?mode=window"
      />
      <KitchenExploreCTA />
      <QuickLinks />
      <NewsWidget source="/news/case-studies" tag="bespoke" />
    </div>
  );
}
